module.exports = __webpack_public_path__ + "img/gift-theOne-title.132c5217.png";